import { ArrowBackIos, ArrowForwardIos, Delete, Edit } from "@mui/icons-material"
import { Box, IconButton, Typography } from "@mui/material"
import { File } from "graphql/types"
import { useState } from "react"
import { getImageURL } from "utils/getFileURL"

type ImageSliderProps = {
  images: File[]
  isDeletable?: boolean
  isEditable?: boolean
  // eslint-disable-next-line no-unused-vars
  onDelete?: (arg: File) => void
  // eslint-disable-next-line no-unused-vars
  onEdit?: (arg: File) => void
}

export const ImageSlider = (props: ImageSliderProps) => {
  const { images, isDeletable = false, isEditable = false, onDelete = () => {}, onEdit = () => {} } = props
  const [currentIndex, setCurrentIndex] = useState(0)

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex >= images.length - 1 ? 0 : prevIndex + 1))
  }

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: 800,
        margin: "0 auto",
        overflow: "hidden",
        height: "300px",
      }}
    >
      {images.length > 0 && (
        <>
          <Box
            component="img"
            src={getImageURL(images[currentIndex].id)}
            alt={images[currentIndex].name}
            sx={{
              width: "100%",
              maxHeight: "calc(100vh - 100px)",
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
            }}
          />
          {(images[currentIndex].name !== "" || images[currentIndex].description) && (
            <Box
              sx={{
                position: "absolute",
                bottom: "0",
                left: "0",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                padding: "8px",
                width: "100%",
                color: "#fff",
                backdropFilter: "blur(5px)",
                display: "flex",
                flexDirection: "column",
                gap: 0.5,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                  {images[currentIndex].name}
                </Typography>
                <Box sx={{ display: "flex", gap: 0.5 }}>
                  {isEditable && (
                    <IconButton
                      onClick={() => onEdit(images[currentIndex])}
                      size="small"
                      sx={{ color: "#fff" }}
                    >
                      <Edit fontSize="small" />
                    </IconButton>
                  )}
                  {isDeletable && (
                    <IconButton
                      onClick={() => {
                        onDelete(images[currentIndex])
                        setCurrentIndex(0)
                      }}
                      size="small"
                      sx={{ color: "#fff" }}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  )}
                </Box>
              </Box>
              {images[currentIndex].description && (
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {images[currentIndex].description}
                </Typography>
              )}
            </Box>
          )}
          {images.length > 1 && (
            <IconButton
              onClick={handlePrev}
              sx={{
                position: "absolute",
                top: "50%",
                left: "0px",
                transform: "translateY(-50%)",
              }}
            >
              <ArrowBackIos />
            </IconButton>
          )}
          {images.length > 1 && (
            <IconButton
              aria-label="Nächstes Bild"
              onClick={handleNext}
              sx={{
                position: "absolute",
                top: "50%",
                right: "0px",
                transform: "translateY(-50%)",
              }}
            >
              <ArrowForwardIos />
            </IconButton>
          )}
        </>
      )}
    </Box>
  )
}
